var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.43353 0.166687H9.37312C10.8429 0.166687 12.0416 1.33335 12.0416 2.75669V9.24335C12.0416 10.6725 10.8429 11.8334 9.36108 11.8334H6.42751C4.95771 11.8334 3.75296 10.6725 3.75296 9.24919V6.44919H7.48769L6.52389 7.38252C6.34317 7.55752 6.34317 7.84335 6.52389 8.01835C6.61424 8.10585 6.73472 8.14669 6.85519 8.14669C6.96965 8.14669 7.09012 8.10585 7.18048 8.01835L8.93941 6.32085C9.02977 6.23919 9.07796 6.12252 9.07796 6.00002C9.07796 5.88335 9.02977 5.76669 8.93941 5.68502L7.18048 3.98752C6.99976 3.81252 6.7046 3.81252 6.52389 3.98752C6.34317 4.16252 6.34317 4.44835 6.52389 4.62335L7.48769 5.55085H3.75296V2.76252C3.75296 1.33335 4.95771 0.166687 6.43353 0.166687ZM0.958313 5.99996C0.958313 5.75496 1.16553 5.5508 1.41419 5.5508H3.75278V6.44913H1.41419C1.16553 6.44913 0.958313 6.2508 0.958313 5.99996Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/Login.eb88df94ef79e7ce5ece7959756f707d.svg";
export { ForwardRef as ReactComponent };